import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CanvasTemplatesDetails = lazy(() =>
  import("@scenes/CanvasTemplates/CanvasTemplatesDetails").then((module) => ({
    default: module.CanvasTemplatesDetails,
  }))
);

export const canvasTemplatesDetailsNRO: NavigationRoutingObject = {
  Component: CanvasTemplatesDetails,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("canvas-templates", "Canvas Templates"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("canvas-templates-description", "Create and manage Canvas templates"),
  icon: "nav-system-canvas",
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/canvas_templates/:appGroupId",
};
